<template>
  <!--位置分类-->
  <category></category>
</template>

<script>
import category from '@/components/package/category.vue';
export default {
  components: {
    category: category
  },
  name: 'locationCate'
};
</script>

<style scoped>

</style>
